module.exports = __webpack_public_path__ + "img/forestDetailSpecies.2fdaf264.svg";